import React, { useMemo } from "react";

import { Table } from "antd";

import { CREDIT_PURCHASE_RATES } from "../constants";

import {
  formatCreditCurrency,
  getRowTotalPrice,
  getTierCellValue,
} from "../utils";

import microscopeIcon from "../../../../assets/images/subscriptions/microscope-line.svg";
import reactjsIcon from "../../../../assets/images/subscriptions/reactjs-line.svg";

import "./CreditPurchaseBreakdownTable.css";

const CATEGORY_ICONS = {
  microbiology: microscopeIcon,
  chemistry: reactjsIcon,
};

function TierCell({ count, cost }) {
  const testCount = Number(count) || 0;
  if (!testCount) {
    return <span>0</span>;
  }

  return (
    <span className="CreditPurchaseBreakdownTable__Tier">
      <span className="CreditPurchaseBreakdownTable__TierCount">
        {testCount.toLocaleString()}
      </span>
      <span className="CreditPurchaseBreakdownTable__TierCost">
        {`(x ${formatCreditCurrency(cost, 2)})`}
      </span>
    </span>
  );
}

function TypeCell({ name, categoryKey }) {
  return (
    <span className="CreditPurchaseBreakdownTable__Type">
      <span className="CreditPurchaseBreakdownTable__TypeIcon">
        <img
          src={CATEGORY_ICONS[categoryKey]}
          alt=""
          aria-hidden
        />
      </span>
      <span className="CreditPurchaseBreakdownTable__TypeName">{name}</span>
    </span>
  );
}

export default function CreditPurchaseBreakdownTable({
  rows = [],
  rates = CREDIT_PURCHASE_RATES,
}) {
  const columns = useMemo(() => {
    const renderTierCell = (tier) => (_, record) => {
      const { count, cost } = getTierCellValue(record, tier, rates);
      return <TierCell count={count} cost={cost} />;
    };

    return [
      {
        title: "Type",
        dataIndex: "name",
        key: "type",
        render: (name, record) => (
          <TypeCell name={name} categoryKey={record.key} />
        ),
      },
      {
        title: "Basic",
        dataIndex: "basic",
        key: "basic",
        align: "center",
        render: renderTierCell("basic"),
      },
      {
        title: "Advanced",
        dataIndex: "advanced",
        key: "advanced",
        align: "center",
        render: renderTierCell("advanced"),
      },
      {
        title: "Specialty",
        dataIndex: "specialty",
        key: "specialty",
        align: "center",
        render: renderTierCell("specialty"),
      },
      {
        title: "Total Price",
        key: "totalPrice",
        align: "center",
        render: (_, record) => (
          <span className="CreditPurchaseBreakdownTable__Total">
            {formatCreditCurrency(getRowTotalPrice(record, rates))}
          </span>
        ),
      },
    ];
  }, [rates]);

  return (
    <Table
      className="CreditPurchaseBreakdownTable"
      columns={columns}
      dataSource={rows}
      pagination={false}
      bordered
      rowKey="key"
      tableLayout="auto"
    />
  );
}
